export const SESSION_SESSION_ID_KEY = 'invision-sessionId';
export const SESSION_NEW_SESSION_ID_KEY = 'invision-new-sessionId';
export const SESSION_IDP_LOGIN_KEY = 'invision-idp-login';
export const SESSION_SYSTEM_ID_KEY = 'invision-systemId';
export const ENVIRONMENT_KEY = 'invision-environment';
export const FORCE_LANGUAGE_OVERRIDE_KEY = 'invision-force-language-override';
export const LANGUAGE_KEY = 'invision-language';
export const LANGUAGE_HEADER_KEY = 'invision-language-header';
export const REDUX_STORE = 'invision-redux';
export const EXPORT_MODE_KEY = 'invision-export-mode';
export const AUTHENTICATION_REDIRECT_KEY = 'invision-authentication-redirect';

/**
 * Tab-scoped opt-in that keeps logout / idle / expiry on the React auth app
 * in environments that are not React-auth-enabled via config. Raw key (no
 * `INV_` prefix) so Angular can read the same value. Angular declares this
 * key independently with a parity comment — there is no shared constant
 * across the Angular and React repos.
 *
 * Only ever stores {@link AUTH_MODE_REACT}; absence means Angular auth.
 *
 * TODO(AB#1355453): Remove this key/value and all auth-mode opt-in read/write/
 * wipe sites once React auth is the default in every environment.
 */
export const AUTH_MODE_KEY = 'invision-auth-mode';

/** Sole positive value for {@link AUTH_MODE_KEY}. Never store a URL here. */
export const AUTH_MODE_REACT = 'react';

export const ENVIRONMENT_NAME = 'invision-environment-name';
export const ENVIRONMENT_VALUE = 'invision-environment-value';
